
define(['jquery', 'underscore', 'require', 'app-common/component/confirm-dialog', 'core', 'common/location'], function($, _, require, confirmDialog, core, location) {
  var TimeoutWarning;
  TimeoutWarning = (function() {
    var apiCall, apiResource, extend, fullTimerMS, getLastLogged, isReactPage, localStorageKey, serverTimeoutSecs, setTimer, showTimeoutMessage, timerId, warn, warningMS, warningMins,
      _this = this;

    function TimeoutWarning() {}

    serverTimeoutSecs = null;

    warningMins = null;

    warningMS = null;

    fullTimerMS = null;

    timerId = null;

    apiCall = null;

    apiResource = 'session';

    localStorageKey = 'benchLastSessionAction';

    getLastLogged = function() {
      return parseInt(window.localStorage.getItem(localStorageKey));
    };

    extend = function(lastLogged) {
      var remainingTime;
      remainingTime = fullTimerMS - (Date.now() - lastLogged);
      return setTimer(remainingTime, lastLogged);
    };

    showTimeoutMessage = function() {
      var message;
      message = "Your session has timed out.<br><br>" + "Click Login to be taken to the login page. Click Dismiss if you have already logged in on another tab.";
      confirmDialog.hide();
      confirmDialog.init(message, {
        ok: "Login",
        cancel: "Dismiss"
      });
      return $('.confirm-ok').on('click', function() {
        var redirectUrl;
        redirectUrl = encodeURIComponent(window.location.href);
        if (JSON.parse(window.localStorage.getItem('openid_okta'))) {
          return window.location.href = "" + location.apiRoot + "/oauth2/authorization/okta?redirect_url=" + redirectUrl;
        } else {
          return window.location.href = ("" + location.websiteRoot + "/login/?session_expired=true&redirect_url=") + redirectUrl;
        }
      });
    };

    isReactPage = function() {
      var pageId;
      pageId = core.getRouter().getCurrentPageState().id;
      return _.contains(['review-tool', 'general-ledger', 'transaction-manager'], pageId);
    };

    warn = function(originalTimestamp) {
      var lastLogged, logoutTimerId, message;
      lastLogged = getLastLogged();
      if (originalTimestamp !== lastLogged) {
        extend(lastLogged);
        return;
      }
      if (isReactPage()) {
        extend(lastLogged);
        apiCall(apiResource, 'keepalive');
        return;
      }
      message = ("You will be logged out in " + warningMins + " minutes due to inactivity.<br><br>") + "Would you like to keep working?";
      confirmDialog.init(message, {
        ok: 'Yes'
      });
      logoutTimerId = window.setTimeout(function() {
        lastLogged = getLastLogged();
        if (originalTimestamp === lastLogged) {
          return showTimeoutMessage();
        } else {
          extend(lastLogged);
          return confirmDialog.hide();
        }
      }, warningMS);
      return $('.confirm-ok').on('click', function() {
        window.clearTimeout(logoutTimerId);
        apiCall(apiResource, 'keepalive');
        return confirmDialog.hide();
      });
    };

    setTimer = function(timeMS, verificationTimestamp) {
      if (timerId) {
        window.clearTimeout(timerId);
      }
      return timerId = window.setTimeout(warn, timeMS, verificationTimestamp);
    };

    TimeoutWarning.prototype.init = function(pWarningMins) {
      var promise;
      if (pWarningMins == null) {
        pWarningMins = 5;
      }
      warningMins = pWarningMins;
      warningMS = warningMins * 60000;
      apiCall = require('app-common/component/api-call');
      promise = apiCall(apiResource, 'timeout');
      return promise.done(function(resp) {
        serverTimeoutSecs = resp;
        return fullTimerMS = serverTimeoutSecs * 1000 - warningMS;
      });
    };

    TimeoutWarning.prototype.reset = function() {
      var now;
      if (!serverTimeoutSecs) {
        return;
      }
      now = Date.now();
      window.localStorage.setItem(localStorageKey, now);
      return setTimer(fullTimerMS, now);
    };

    return TimeoutWarning;

  }).call(this);
  return new TimeoutWarning();
});
